<script>

import { mapState } from 'vuex';
import SkiDatePicker from '../ski/rental/SkiDatePicker';

export default {
  name: 'ItineraryEditPosterFooter',
  components: { SkiDatePicker },
  props: {
    itineraryPoster: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    ...mapState({
      itinerary: state => state.itinerary.edit.item,
      loading: state => state.itinerary.edit.loading,
    }),
  },
  methods: {
    updateField(value, field, section) {
      this.$emit('updateField', value, field, section);
    },
  },
};
</script>
<template>
  <v-card class="poster-footer-card">
    <v-card-title class="pb-0">
      <div class="headline">Footer</div>
    </v-card-title>
    <v-card-text class="d-flex flex-col gap-6 pt-4">
      <div class="footer-section">
        <div class="text-subtitle-2 mb-2">Deadline Information</div>
        <div class="d-flex gap-4">
          <v-text-field
            v-model="itineraryPoster.footer.deadline.title"
            :loading="loading"
            label="Title"
            variant="outlined"
            density="comfortable"
            hide-details
            class="flex-1"
            @input="updateField($event,'title', 'deadline')"
          />

          <div class="flex-1">
            <ski-date-picker
              :date.sync="itineraryPoster.footer.deadline.date"
              title="Date"
              @onChange="itineraryPoster.footer.deadline.date = $event"
            />
          </div>

          <v-text-field
            v-model="itineraryPoster.footer.deadline.text"
            :loading="loading"
            label="Text"
            variant="outlined"
            density="comfortable"
            hide-details
            class="flex-2"
            @input="updateField($event,'text', 'deadline')"
          />
        </div>
      </div>

      <div class="footer-section">
        <div class="text-subtitle-2 mb-2">Lead Contact</div>
        <div class="d-flex gap-4">
          <v-text-field
            v-model="itineraryPoster.footer.lead.text"
            :loading="loading"
            label="Text"
            variant="outlined"
            density="comfortable"
            hide-details
            class="flex-1"
            @input="updateField($event,'text', 'lead')"
          />

          <v-text-field
            v-model="itineraryPoster.footer.lead.name"
            :loading="loading"
            label="Name"
            variant="outlined"
            density="comfortable"
            hide-details
            class="flex-1"
            @input="updateField($event,'name', 'lead')"
          />

          <div class="d-flex gap-4 flex-2">
            <v-text-field
              v-model="itineraryPoster.footer.lead.email"
              :loading="loading"
              label="Email"
              variant="outlined"
              density="comfortable"
              hide-details
              class="flex-1"
              @input="updateField($event, 'email', 'lead')"
            />

            <v-text-field
              v-model="itineraryPoster.footer.lead.phone"
              :loading="loading"
              label="Phone"
              variant="outlined"
              density="comfortable"
              hide-details
              class="flex-1"
              @input="updateField($event, 'phone', 'lead')"
            />
          </div>
        </div>
      </div>

      <div class="footer-section">
        <div class="text-subtitle-2 mb-2">Brand Contact</div>
        <div class="d-flex gap-4">
          <v-text-field
            v-model="itineraryPoster.footer.brand.text"
            :loading="loading"
            label="Text"
            variant="outlined"
            density="comfortable"
            hide-details
            class="flex-1"
            @input="updateField($event,'text', 'brand')"
          />

          <v-text-field
            v-model="itineraryPoster.footer.brand.name"
            :loading="loading"
            label="Name"
            variant="outlined"
            density="comfortable"
            hide-details
            class="flex-1"
            @input="updateField($event,'name', 'brand')"
          />

          <div class="d-flex gap-4 flex-2">
            <v-text-field
              v-model="itineraryPoster.footer.brand.email"
              :loading="loading"
              label="Email"
              variant="outlined"
              density="comfortable"
              hide-details
              class="flex-1"
              @input="updateField($event,'email', 'brand')"
            />

            <v-text-field
              v-model="itineraryPoster.footer.brand.phone"
              :loading="loading"
              label="Phone"
              variant="outlined"
              density="comfortable"
              hide-details
              class="flex-1"
              @input="updateField($event,'phone', 'brand')"
            />
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped lang="scss">
.poster-footer-card {
  border-radius: 12px;
}

.footer-section {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 16px;
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}

.gap-4 {
  gap: 1rem;
}

.gap-6 {
  gap: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryEditPosterFooter.vue